/** 重要性 → 颜色 / 标签 */
export function importanceLabel(level: number): { label: string; color: string } {
  switch (level) {
    case 2:
      return { label: '高', color: 'text-red-500' };
    case 1:
      return { label: '中', color: 'text-orange-500' };
    default:
      return { label: '低', color: 'text-gray-400' };
  }
}

/** ISO 字符串 → datetime-local 输入框格式 */
export function toLocalInput(ts: number | null | undefined): string {
  if (!ts) return '';
  const d = new Date(ts);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** datetime-local 输入框格式 → ms */
export function fromLocalInput(s: string): number | null {
  if (!s) return null;
  return new Date(s).getTime();
}